/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  FileAsAStream,
  SmsBatchCreateRequest,
  SmsBatchCreateResponse,
  SmsBatchListResponse,
  SmsBatchStatusResponse,
  SmsBatchValidationResponse,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Validates a CSV of SMS batch recipients
 */
export const validateSmsBatch = (
  fileAsAStream: FileAsAStream,
  options?: SecondParameter<
    typeof backofficeRequest<SmsBatchValidationResponse>
  >,
) => {
  const formData = new FormData()
  formData.append(`file`, fileAsAStream.file)

  return backofficeRequest<SmsBatchValidationResponse>(
    {
      url: `/communication/sms-batch/validate`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
    },
    options,
  )
}
/**
 * @summary Lists SMS batches created in the last 7 days
 */
export const listSmsBatches = (
  options?: SecondParameter<typeof backofficeRequest<SmsBatchListResponse>>,
) => {
  return backofficeRequest<SmsBatchListResponse>(
    { url: `/communication/sms-batch`, method: "GET" },
    options,
  )
}
/**
 * @summary Creates an SMS batch from the uploaded CSV
 */
export const createSmsBatch = (
  smsBatchCreateRequest: SmsBatchCreateRequest,
  options?: SecondParameter<typeof backofficeRequest<SmsBatchCreateResponse>>,
) => {
  const formData = new FormData()
  formData.append(`file`, smsBatchCreateRequest.file)
  formData.append(`messageBody`, smsBatchCreateRequest.messageBody)

  return backofficeRequest<SmsBatchCreateResponse>(
    {
      url: `/communication/sms-batch`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
    },
    options,
  )
}
/**
 * @summary Gets the status of an SMS batch
 */
export const getSmsBatchStatus = (
  batchId: number,
  options?: SecondParameter<typeof backofficeRequest<SmsBatchStatusResponse>>,
) => {
  return backofficeRequest<SmsBatchStatusResponse>(
    { url: `/communication/sms-batch/${batchId}/status`, method: "GET" },
    options,
  )
}
export type ValidateSmsBatchResult = NonNullable<
  Awaited<ReturnType<typeof validateSmsBatch>>
>
export type ListSmsBatchesResult = NonNullable<
  Awaited<ReturnType<typeof listSmsBatches>>
>
export type CreateSmsBatchResult = NonNullable<
  Awaited<ReturnType<typeof createSmsBatch>>
>
export type GetSmsBatchStatusResult = NonNullable<
  Awaited<ReturnType<typeof getSmsBatchStatus>>
>
